import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
export const ConditionalWrapper = React.memo(function ConditionalWrapper(props) {
    const { children, condition, Wrapper, ...rest } = props;
    return condition ? _jsx(Wrapper, { ...rest, children: children }) : children;
});
//# sourceMappingURL=ConditionalWrapper.js.map